import React, { useContext, useEffect, useState } from 'react';
import { MenuItem, MenuList, Paper, Popover, Typography } from '@material-ui/core';
import CmtAvatar from '../../../../@coremat/CmtAvatar';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useDispatch, useSelector } from 'react-redux';
import { AuhMethods } from '../../../../services/auth';
import { CurrentAuthMethod } from '../../../constants/AppConstants';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import PersonIcon from '@material-ui/icons/Person';
import SettingsIcon from '@material-ui/icons/Settings';
import SidebarThemeContext from '../../../../@coremat/CmtLayouts/SidebarThemeContext/SidebarThemeContext';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from '@jumbo/constants/ActionTypes';
import authHeader from 'services/auth/jwt/auth-header';
import customAxios from 'routes/Pages/util/Api';
import { jwtDecode } from 'jwt-decode';

const useStyles = makeStyles(theme => ({
  root: {
    paddingLeft: '15px',
    borderBottom: props => `solid 1px ${props.sidebarTheme.borderColor}`,
  },
  userInfo: {
    paddingTop: 24,
    transition: 'all 0.1s ease',
    height: 75,
    opacity: 1,
    '.Cmt-miniLayout .Cmt-sidebar-content:not(:hover) &': {
      height: 0,
      paddingTop: 0,
      opacity: 0,
      transition: 'all 0.3s ease',
    },
  },
  userTitle: {
    color: props => props.sidebarTheme.textDarkColor,
    marginBottom: 8,
  },
  userSubTitle: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightBold,
    letterSpacing: 0.25,
  },
}));

const SidebarHeader = () => {
  const { sidebarTheme } = useContext(SidebarThemeContext);
  const classes = useStyles({ sidebarTheme });
  const [userDetails, setUserDetails] = useState({});
  const { authUser } = useSelector(({ auth }) => auth);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const dispatch = useDispatch();
  const handlePopoverOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const onLogoutClick = () => {
    handlePopoverClose();
    dispatch(AuhMethods[CurrentAuthMethod].onLogout());
  };

  const getUserProfileDetails = () => {
    dispatch({ type: FETCH_START });

    try {
      const token = JSON.parse(localStorage.getItem('token'));
      console.log(token);
      if (token) {
        let userData = jwtDecode(token);
        console.log(userData);
        setUserDetails(userData);
      }
      return;
      customAxios
        .get('User/GetUserProfile', { headers: authHeader() })
        .then(({ data }) => {
          let correctedData = data;
          correctedData['AvatarImage'] = `data:image/jpeg;base64,${data.AvatarImage}`;
          setUserDetails(correctedData);
          dispatch({ type: FETCH_SUCCESS });
        })
        .catch(error => {});
    } catch (e) {
      dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
    }
  };

  function stringAvatar(name) {
    return name
      ? {
          // sx: {
          //   bgcolor: stringToColor(name),
          // },

          children: `${name.charAt(0)}${name.charAt(1)}`,
        }
      : null;
  }

  useEffect(() => {
    //getUserProfileDetails();
  }, []);

  return (
    <div
      style={{ minHeight: '81px', display: 'flex', justifyContent: 'start', alignItems: 'center' }}
      className={classes.root}>
      <CmtAvatar alt="User Avatar" src={userDetails.AvatarImage} {...stringAvatar(userDetails.EmailAddress)} />
    </div>
  );
};

export default SidebarHeader;
